import { Text } from '@skin-seoul/design-system';
import { CLASSNAME } from '@skin-seoul/service';
interface CategoryTextItemProps {
  name: string;
  isActive: boolean;
  onClick: () => void;
  textStyle?: 'paragraph.medium' | 'label.large';
  padding?: number;
}
const CategoryTextItem = ({
  name,
  isActive,
  onClick,
  textStyle = 'label.large',
  padding = 1
}: CategoryTextItemProps) => {
  return <Text fontWeight="regular" textStyle={textStyle} color={isActive ? 'primary.500' : 'neutral.600'} cursor="pointer" onClick={onClick} _hover={{
    color: 'primary.500'
  }} transition="all 0.2s" padding={padding} className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Text" data-sentry-component="CategoryTextItem" data-sentry-source-file="CategoryTextItem.tsx">
      {name}
    </Text>;
};
export default CategoryTextItem;